export default "__VITE_ASSET__CasbbZFV__"